import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useGlobal } from 'context/global/GlobalContext';
import validateNewDtcVisitor from 'utils/validateNewDtcVisitor';

const useRedirectLink = () => {
  const { logEvent, productDetails } = useGlobal();
  const history = useHistory();

  const redirectToExternalLink = useCallback(
    (
      url?: string | URL,
      target?: string,
      features?: string,
      internal?: boolean
    ) => {
      logEvent({
        eventType: 'ENGAGEMENTS',
        event: 'WEBSITE_VISITS',
        data: { url },
        customerNewDtcVisitor: validateNewDtcVisitor(
          productDetails?.brand?.website,
          productDetails?.brand?.shopifyStoreName
        ),
      });

      let link: string | URL | undefined = url as string;

      if (internal) {
        history.push(link);
      } else if (link.includes('https://') || link.includes('http://')) {
        window.open(`${url}`, target, features);
      } else window.open(`${'https://'}${url}`, target, features);
    },
    [logEvent]
  );

  return redirectToExternalLink;
};

export default useRedirectLink;
